/* eslint-disable react/jsx-no-undef */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Card, Collapse } from 'antd';
import { isEmpty } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/pro-light-svg-icons';
import ThemeXModal from 'Src/common/components/themeXModal';
import ProfileListItem from '../profileListItem';

import './style.scss';

const TYPE_EMAIL = 'email';
const TYPE_EMAIL_ADDRESSES = 'email_addresses';

const MAX_DATA_BLOCK_VALUE_LENGTH = 200;

/**
 * Compare component, this is used to compare two records, one for which activity
 * is logged and one for which profile is selected
 * @param {*} activityData - data of activity
 * @param {*} profileData - data of profile
 * @param {*} record - a mapped profile
 * @param {*} isVFXEnabled - is vfx enabled for site
 */
function Compare({
  // eslint-disable-next-line no-trailing-spaces
  activityData,
  profileData,
  record,
  isVFXEnabled,
  version = 2,
}) {
  const [openViewMoreModal, setOpenViewMoreModal] = useState(false);
  const [viewMoreLabel, setViewMoreLabel] = useState('');
  const [viewMoreValue, setViewMoreValue] = useState('');

  /**
   * This function will toggle viewMoreModal
   */
  function toggleViewMoreModal() {
    setOpenViewMoreModal(!openViewMoreModal);
  }

  /**
   * DataBlock for single data block for compare
   * @param {*} label
   * @param {*} value
   */
  function DataBlock({ data }) {
    const { label, value, type } = data;
    const isViewMoreVisible = typeof value === 'string' && value.length > MAX_DATA_BLOCK_VALUE_LENGTH;
    let valueToShow = isViewMoreVisible ? value.substring(0, MAX_DATA_BLOCK_VALUE_LENGTH + 1) : value;

    if (type == TYPE_EMAIL_ADDRESSES) {
      valueToShow = (
        <ul className="arc-p arc-color-B45 pl16">
          {(Array.isArray(value) ? value : []).map((value) => (
            <li key={value.id}>{value?.address || '-'}</li>
          ))}
        </ul>
      );

      if (isEmpty(value)) valueToShow = '-';
    }

    /**
     * This function will set values of view more states and open the view more modal.
     */
    function handleViewMore() {
      setViewMoreLabel(label);
      setViewMoreValue(value);
      toggleViewMoreModal();
    }

    return (
      <div className="data-block">
        <p className="arc-p arc-font-weight-700 arc-color-B65 arc-H150">{label}</p>
        <p className="arc-p arc-font-weight-400 arc-color-B65">
          <span className="mr16">{valueToShow || '-'}</span>
          <If condition={type === TYPE_EMAIL && activityData?.isNewEmail}>
            <span className="new-email-tag arc-font-weight-bold">New Email</span>
          </If>
          <If condition={isViewMoreVisible}>
            <p className="blurred-footer" />
          </If>
        </p>
        <If condition={isViewMoreVisible}>
          <div className="view-more-container arc-text-align-c">
            <span className="arc-color-primary arc-cursor-p" onClick={handleViewMore}>
              View more
            </span>
          </div>
        </If>
      </div>
    );
  }

  const getClassnameByVersion = (oldClass, newClass) => {
    if (version === 2) {
      return ' ' + oldClass;
    } else return ' ' + newClass;
  };

  return (
    <div className={'compare-wrapper ' + getClassnameByVersion('arc-page-bg', 'mapper-v3-compare')}>
      <p className="arc-p arc-color-B55 arc-H150">Details captured from activity:</p>
      <Card className="arc-card-box-shadow arc-card-border-radius mt4 mb16">
        <DataBlock data={{ label: 'Name', value: activityData?.title }} />
        {(activityData?.nonCollapsibleData || []).map((data) => (
          <DataBlock data={data} />
        ))}
        {!isEmpty(activityData?.collapsibleData) && (
          <Collapse defaultActiveKey={['0']} ghost>
            <Collapse.Panel header={<p className="arc-color-primary">{activityData?.collapsibleDataTitle}</p>} key="1">
              {(activityData?.collapsibleData || []).map((data) => (
                <DataBlock data={data} />
              ))}
            </Collapse.Panel>
          </Collapse>
        )}
      </Card>
      <p className="arc-p arc-color-B55 mt16 arc-H150">Profile on directory:</p>
      <Card className="arc-card-box-shadow arc-card-border-radius mt4 mb16">
        <div className="mb16">
          <ProfileListItem record={record} isActionEnabled={false} isVFXEnabled={isVFXEnabled} />
        </div>
        {(profileData?.nonCollapsibleData || []).map((data) => (
          <DataBlock data={data} />
        ))}
        <If condition={record.external_database_id}>
          <div className="mb8">
            <a
              href={`https://host.nxt.blackbaud.com/constituent/records/${record.external_database_id}`}
              className="arc-p arc-primary-color"
              target="_blank"
              rel="noopener noreferrer">
              <FontAwesomeIcon icon={faExternalLink} className="mr4" />
              <span>
                View on
                {window.isExternalDatabaseBBCRM ? ' BBCRM' : " Raiser's Edge"}
              </span>
            </a>
          </div>
        </If>
        <a href={record.profile_url} className="arc-p arc-primary-color" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faExternalLink} className="mr4" />
          <span>View full profile</span>
        </a>
      </Card>
      <ThemeXModal
        visible={openViewMoreModal}
        width={1056}
        modalTitle={viewMoreLabel}
        handleCancel={toggleViewMoreModal}>
        <div className="p24" dangerouslySetInnerHTML={{ __html: viewMoreValue }} />
      </ThemeXModal>
    </div>
  );
}

export default Compare;
